import { render, staticRenderFns } from "./InsertEditComponent.vue?vue&type=template&id=17b4a2da&scoped=true"
import script from "./InsertEditComponent.vue?vue&type=script&lang=js"
export * from "./InsertEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4a2da",
  null
  
)

export default component.exports